import axiosInstance from "./axiosInstance";

export const fetchCourses = async () => {
  try {
    const res = await axiosInstance.get("/getcourses");
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const createEvent = async (eventData) => {
  try {
    const res = await axiosInstance.post("/course", eventData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCourseById = async (userId) => {
  if (!userId) throw new Error("User ID is required");
  try {
    const res = await axiosInstance.get(`/course/${userId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCourseStudentById = async (userId) => {
  if (!userId) throw new Error("UserID is required");
  try {
    const res = await axiosInstance.get(`/studentcourses/${userId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCourse = async (courseId) => {
  try {
    const res = await axiosInstance.delete(`/courses/${courseId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateCourse = async (courseId, updatedData) => {
  try {
    const res = await axiosInstance.put(`/courses/${courseId}`, updatedData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getCourseById = async (id) => {
  try {
    const res = await axiosInstance.get(`/courses/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchReviewsByEventId = async (id) => {
  try {
    const res = await axiosInstance.get(`/getreview/${id}`);
    return res.data;
  } catch (error) {
    return [];
  }
};

export const fetchReviewsByCourseId = async (id) => {
  try {
    const res = await axiosInstance.get(`/getCourseReview/${id}`);
    return res.data;
  } catch (err) {
    console.error("Error in fetching course reviews:", err);
  }
};

export const markCourseVideoCompleted = async (data) => {
  try {
    const res = await axiosInstance.post("/mark-video-completed", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const createCourseOrder = async (orderData) => {
  try {
    const res = await axiosInstance.post("/order", orderData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const sendCoursePaymentEmail = async (emailData) => {
  try {
    const res = await axiosInstance.post("/mail", emailData);
    return res.data;
  } catch (error) {
    throw error;
  }
};
